import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '../../../../../../../icons/Icon';
import { ICONS } from '../../../../../../../icons';
import useH2HConceptsOptions from '../../hooks/useH2HConceptsOptions';
import NoDataDisclaimer from '../../../no-data-disclaimer/NoDataDisclaimer';

import scss from './DisclaimerH2H.module.scss';

function DisclaimerH2H() {
  const { t } = useTranslation('resonance');

  const conceptH2HOptions = useH2HConceptsOptions();

  if (conceptH2HOptions && !conceptH2HOptions.length) {
    return <NoDataDisclaimer title={t('noConceptsH2HInTheProject')} />;
  }

  return (
    <div className={scss.wrapper}>
      <div className={scss.titleWrapper}>
        <Icon icon={ICONS.Unclust} className={scss.icon} disableCommonStyles currentColor />
        <h3>{t('noData')}</h3>
      </div>
      <span className={scss.subtitle}>
        {t('pleaseSelectAtLeastOne')}
        <span className={scss.subtitleItem}>{t('headToHead')}</span>
      </span>
    </div>
  );
}

export default DisclaimerH2H;
